<template>
  <div>
    <blog-desktop v-if="screenType ==='desktop'"></blog-desktop>
    <blog-mobile v-else></blog-mobile>
  </div>
</template>

<script>
import BlogDesktop from "@/components/Pages/Desktop/Blog/BlogDesktop";
import BlogMobile from "@/components/Pages/Mobile/Blog/BlogMobile";

export default {
  name: "BlogMain",
  components: {BlogMobile, BlogDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>